// import logo from './logo.svg';
// import './App.css';

function App() {
  window.location.href = "https://drive.google.com/file/d/1sfk4zpP-hrKnEV3fD82uF82jZG6dPRKE/view?usp=drivesdk";
}

export default App;
